import { put, takeLatest } from 'redux-saga/effects';
import { fetchSRPInitialLoadFailure, fetchSRPInitialLoadSuccess, fetchSRPMapSuccess } from './srpSlice';
import { fetchDisabledFilterFailure, fetchDisabledFilterSuccess, fetchSRPFilterInitialLoadFailure, fetchSRPFilterInitialLoadSuccess, fetchSRPSortInitialLoadFailure, fetchSRPSortInitialLoadSuccess } from './srpFilterSlice';
import { fetchAutocompleteSuccess, fetchAutocompleteFailure, setSearchParam } from './srpSearchSlice';
import { getAutocompleteSuggestions, getDisabledFilters, getSRP, getSRPMap } from '@/api/srp';
import { filterList, sortFilterConfig } from './data';

export function* fetchSRPInitSaga(action) {
  const pageNumber = action?.payload?.pageNumber;
  const url = action?.payload?.url;
  const fullURL = url + (pageNumber ? `&pageNumber=${pageNumber}` : '');
  const response = yield getSRP(fullURL);
  if (response) {
    yield put(fetchSRPInitialLoadSuccess({data: response, isNearBy: response?.totalNearbyResultCount > 0 ? true : false}));
    if (response?.filterConfig?.filterList) {
      yield put(fetchSRPFilterInitialLoadSuccess(response?.filterConfig?.filterList));
      yield put(setSearchParam(""));
      const disabledFilters = yield getDisabledFilters(fullURL);
      if (disabledFilters) {
        yield put(fetchDisabledFilterSuccess(disabledFilters));
      } else {
        yield put(fetchDisabledFilterFailure(["CLOSEOUTS", "MAC", "AUS", "CP", "CVS", "GST", "HNC", "HRM", "MU", "OFS", "PF", "RNB", "SU", "WRH"]));
      }
    } else {
      yield put(fetchSRPFilterInitialLoadFailure(filterList));
    }
    if (response?.filterConfig?.sortFilterConfig) {
      yield put(fetchSRPSortInitialLoadSuccess(response?.filterConfig?.sortFilterConfig));
    } else {
      yield put(fetchSRPSortInitialLoadFailure(sortFilterConfig));
    }
    const mapResponse = yield getSRPMap(url);
    if (mapResponse) {
      yield put(fetchSRPMapSuccess({data: mapResponse, isNearBy: url.includes("near-by") ? true : false}));
    }
  } else {
    yield put(fetchSRPInitialLoadFailure());
    yield put(fetchSRPFilterInitialLoadFailure(filterList));
    yield put(fetchSRPSortInitialLoadFailure(sortFilterConfig));
    yield put(setSearchParam(""));
  }
}

export function* watchFetchSRPInitSaga() {
  yield takeLatest('srp/fetchSRPInitialLoad', fetchSRPInitSaga);
}

export function* fetchAutocompleteSaga(action) {
  const { query, category } = action.payload;
  const response = yield getAutocompleteSuggestions(query, category);
  if (!response?.errorMessage) {
    yield put(fetchAutocompleteSuccess(response?.suggestions));
  } else {
    yield put(fetchAutocompleteFailure(response?.errorMessage));
  }
}
export function* watchFetchAutocompleteSaga() {
  yield takeLatest('srpSearch/fetchAutocompleteRequest', fetchAutocompleteSaga);
}
